import axios from 'axios'

let http = axios.create({
  timeout: 6000000,
  // withCredentials: false,
});

/*请求拦截器*/
http.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
});

/*响应拦截器*/
http.interceptors.response.use(response => {
  //拦截器根据请求返回码判断，当返回码为11001未登录状态，进行跳转
  if (response.data.code == 11001) {
    return (location.href = response.data.redirectUrl)
  }
  if (response.data.code === "0000") {
    response.data.code = 200
  }
  return response
}, error => {
  console.log(98,error)
  return Promise.reject(error.response?error.response.data.status.toString():'');
})

let get = function (url, params = {}, config = {}) {
  return new Promise((resolve, reject) => {
    http
      .get(url, { params: params }, config)
      .then(
        res => {
          resolve(res.data)
        },
        err => {
          reject(err)
        }
      )
      .catch(err => {
        reject('网络连接失败，请稍后重试')
      })
  })
}

let post = function (url, params = {}, config = {}) {
  return new Promise((resolve, reject) => {
    http
      .post(url, params, config)
      .then(
        res => {
          resolve(res.data)
        },
        err => {
          reject(err)
        }
      )
      .catch(err => {
        reject('网络连接失败，请稍后重试')
      })
  })
}

let del = function (url, params = {}, config = {}) {
  return new Promise((resolve, reject) => {
    http
      .delete(url, { params: params }, config)
      .then(
        res => {
          resolve(res.data)
        },
        err => {
          reject(err)
        }
      )
      .catch(err => {
        reject('网络连接失败，请稍后重试')
      })
  })
}

export { post, get, del }


// WEBPACK FOOTER //
// ./src/api/http.js